import { InjectionToken } from '@angular/core';
import { GridOptions } from 'ag-grid-community';

export const XPO_BOARD_AG_GRID_DEFAULT_GRID_OPTIONS = new InjectionToken<GridOptions>('XpoBoardAgGridDefaultOptions');
